<div class="otp-container">
  <div class="otp-header">
    <!-- <h2>Código de verificación</h2>
    <p>Ingrese el código de 6 dígitos que recibió</p> -->
  </div>

  <form [formGroup]="step2Form">
    <div class="otp-inputs">
      <input placeholder="0"
        type="text"
        id="digit1"
        class="otp-input"
        formControlName="digit1"
        maxlength="1"
        inputmode="numeric"
        pattern="[0-9]"
        (input)="onDigitInput($event, 'digit2', '')"
        (keydown)="onKeyDown($event, 'digit2', '')"
        (focus)="onFocus($event)"
        (paste)="onPaste($event)"
        autocomplete="off">
      
      <input placeholder="0"
        type="text" 
        id="digit2"
        class="otp-input"
        formControlName="digit2"
        maxlength="1"
        inputmode="numeric"
        pattern="[0-9]"
        (input)="onDigitInput($event, 'digit3', 'digit1')"
        (keydown)="onKeyDown($event, 'digit3', 'digit1')"
        (focus)="onFocus($event)"
        autocomplete="off">
      
      <input placeholder="0"
        type="text" 
        id="digit3"
        class="otp-input"
        formControlName="digit3"
        maxlength="1"
        inputmode="numeric"
        pattern="[0-9]"
        (input)="onDigitInput($event, 'digit4', 'digit2')"
        (keydown)="onKeyDown($event, 'digit4', 'digit2')"
        (focus)="onFocus($event)"
        autocomplete="off">
      
      <input placeholder="0"
        type="text" 
        id="digit4"
        class="otp-input"
        formControlName="digit4"
        maxlength="1"
        inputmode="numeric"
        pattern="[0-9]"
        (input)="onDigitInput($event, 'digit5', 'digit3')"
        (keydown)="onKeyDown($event, 'digit5', 'digit3')"
        (focus)="onFocus($event)"
        autocomplete="off">
      
      <input placeholder="0"
        type="text" 
        id="digit5"
        class="otp-input"
        formControlName="digit5"
        maxlength="1"
        inputmode="numeric"
        pattern="[0-9]"
        (input)="onDigitInput($event, 'digit6', 'digit4')"
        (keydown)="onKeyDown($event, 'digit6', 'digit4')"
        (focus)="onFocus($event)"
        autocomplete="off">
      
      <input placeholder="0"
        type="text" 
        id="digit6"
        class="otp-input"
        formControlName="digit6"
        maxlength="1"
        inputmode="numeric"
        pattern="[0-9]"
        (input)="onDigitInput($event, '', 'digit5')"
        (keydown)="onKeyDown($event, 'digit6', 'digit5')"
        (focus)="onFocus($event)"
        autocomplete="off">
    </div>

    <div class="error-message" *ngIf="hasError()">
      <mat-icon>error_outline</mat-icon>
      <span>Por favor, ingrese el código completo</span>
    </div>
  </form>
</div>